module.exports.SUPPORTED_LOCALES = ["en"];



// WEBPACK FOOTER //
// ./common/constants/languages/index.js